import React from 'react';
import { Mail, ArrowUpRight } from 'lucide-react';
import { Reveal } from '../Reveal';
import { coach } from '../../config/coach';

const ContactSection = () => {
  const scrollToApply = () => document.getElementById('apply')?.scrollIntoView({ behavior: 'smooth' });

  return (
    <section id="contact" className="relative bg-black py-24 sm:py-32 overflow-hidden" data-testid="contact-section">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="w-[36rem] h-[36rem] bg-white/[0.04] rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 mx-auto max-w-3xl px-5 sm:px-8 text-center">
        <Reveal><span className="kicker justify-center before:hidden">{coach.contact.kicker}</span></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-bold uppercase text-white tracking-tight leading-[0.88] text-5xl sm:text-7xl lg:text-8xl mt-4">
            {coach.contact.heading}
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 text-white/60 text-base sm:text-lg max-w-md mx-auto">{coach.contact.sub}</p>
        </Reveal>

        <Reveal delay={0.15}>
          <div className="mt-10 flex flex-col items-center gap-6">
            <button onClick={scrollToApply} data-testid="contact-apply-btn" className="btn-primary">
              Apply for Coaching
            </button>

            <a
              href={`mailto:${coach.email}`}
              data-testid="contact-email-link"
              className="group inline-flex items-center gap-2 text-white/70 hover:text-white transition-colors"
            >
              <Mail className="w-4 h-4" />
              <span className="text-sm sm:text-base tracking-wide underline underline-offset-4 decoration-white/20 group-hover:decoration-white">
                {coach.email}
              </span>
              <ArrowUpRight className="w-4 h-4 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default ContactSection;
